import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation]);

export default new (class {
    constructor() {
        this.wrapSelector = ".cards"
        this.sliderContainerSelector = ".cards .swiper"
        this.sliderNextSelector = ".cards .cards-arrows .cards-next"
        this.sliderPrevSelector = ".cards .cards-arrows .cards-prev"
        this.sliderImagesSelector = 

        this.handler()

    }
    handler() {
        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        this.slider = document.querySelector(`${this.sliderContainerSelector}`)

        if (!this.slider || this.slider.classList.contains('swiper-initialized')) return;

        this.wrap = document.querySelector(this.wrapSelector);

        this.arrowsNext = document.querySelectorAll(this.sliderNextSelector);
        this.arrowsPrev = document.querySelectorAll(this.sliderPrevSelector);


        this.slideNext = ({target}) => {
            if (this.swiperSlider) {
                this.swiperSlider.slideNext()
            }
            this.wrap.querySelectorAll('.cards-active').forEach(item => {
                if (item.nextElementSibling) {
                    item.classList.remove('cards-active');
                    item.nextElementSibling.classList.add('cards-active')
                }
            })
        }

        this.slidePrev = ({target}) => {
            if (this.swiperSlider) {
                this.swiperSlider.slidePrev();
            }
            this.wrap.querySelectorAll('.cards-active').forEach(item => {
                if (item.previousElementSibling) {
                    item.classList.remove('cards-active');
                    item.previousElementSibling.classList.add('cards-active')
                }
            })
        }

        this.slideClick = ({target}) => {
            const slide = target.closest('.swiper-slide')
            if (slide) {
                if (this.swiperSlider) {
                    this.swiperSlider.slideTo(+slide.dataset.index - 1);
                }

                this.wrap.querySelectorAll(`.cards-images [data-index], .cards-texts [data-index], .swiper [data-index]`).forEach(item => {
                    item.classList.remove('cards-active');
                    if (item.dataset.index == slide.dataset.index) {
                        item.classList.add('cards-active')
                    }
                })
            }
        }

        this.slider.addEventListener('click', this.slideClick);

        this.arrowsPrev.forEach((btn) => {
            btn.addEventListener('click', this.slidePrev)
        })
        this.arrowsNext.forEach((btn) => {
            btn.addEventListener('click', this.slideNext)
        })

        
        let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)');
        if (!mobile.matches) return;

        this.swiperSlider = new Swiper(this.slider, {
            slidesPerView: 'auto',
            spaceBetween: 4,
            slideToClickedSlide: true,
        })

    }

    destroy() {
        if (this.swiperSlider) {
            this.swiperSlider.destroy();
            this.swiperSlider = null;

            this.arrowsNext.forEach(btn => {
                btn.removeEventListener(this.slideNext)
            })

            this.arrowsPrev.forEach(btn => {
                btn.removeEventListener(this.slidePrev)
            })

            this.slider.removeEventListener(this.slideClick);
        }
    }
})();
